module.exports = __webpack_public_path__ + "static/map-a47cc8effb529d06ea429fdd4a5b48bb.svg";